import React from "react";
import OrderCard from "./OrderCard";
import OrderHeader from "./OrderHeader";
const OrderTable = ({
  orders,
  latestId,
  newOrderFlag,
  onRowClick,
  openChatDrawer,
}) => {
  return (
    <div className="min-w-[1280px] space-y-2 h-[72vh] overflow-y-auto px-2">
      <OrderHeader />
      {orders.map((order, index) => (
        <OrderCard
  key={order.orderId}
  data={order}
  isNew={order.orderId === latestId && newOrderFlag}
  isLatest={index === 0}
  onClick={onRowClick}
  openChatDrawer={openChatDrawer}
/>
      ))}
    </div>
  );
}
export default OrderTable
